// removed by extract-text-webpack-plugin
module.exports = {"header":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-DeleteRecipientModal-__DeleteRecipientModal___1T9M0"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/AccountSetting/EmailNotification/EmailNotificationForm/DeleteRecipientModal/DeleteRecipientModal.css
// module id = 2047
// module chunks = 0